import React, { useState } from "react"
import CustomImage from "@/main/customImage"
import { VerticalTimelineElement } from "react-vertical-timeline-component"

import { useSpring, animated } from "react-spring"
import { Waypoint } from "react-waypoint"

import { Col, Row } from "react-bootstrap"

function TimelineElement(props) {
    const [inView, setInView] = useState(false)

    const fadeUp = useSpring({
        delay: 500,
        to: {
            opacity: inView ? 1 : 0,
            marginTop: inView ? 0 : 50,
        },
    })
    return (
        <>
            <Waypoint onEnter={() => setInView(true)}>
                <animated.div className="mb-3" style={fadeUp}>
                    <VerticalTimelineElement
                        position={props.position}
                        icon={
                            <p className="text-center mt-1 mt-xl-2 text-white">
                                {props.sequence}
                            </p>
                        }
                        iconStyle={{
                            background: "rgba(243, 112, 33, 0.8)",
                            border: "none",
                            color: "#f37021",
                        }}
                        contentStyle={{
                            borderRadius: "0",
                            boxShadow: "0 5px 20px 0 rgba(0, 0, 0, 0.03)",
                            padding: "0",
                        }}
                    >
                        <Row className="d-none d-md-flex align-items-center">
                            {props.position === "left" && (
                                <>
                                    <Col sm={12} md={6} lg={4}>
                                        <div className="timeline-img">
                                            <CustomImage
                                                src={`https://webb-jenkins-static-164679926.imgix.net/${props.image}`}
                                                alt={props.alt}
                                                layout="fill"
                                                objectFit="cover"
                                                objectPosition="center"
                                                sizes="50vw"
                                            />
                                        </div>
                                    </Col>
                                    <Col className="pt-4 pb-5 ps-4 pe-6 text-lg-center">
                                        <h3 className="h4">{props.title}</h3>
                                        <p>{props.description}</p>
                                    </Col>
                                </>
                            )}

                            {props.position === "right" && (
                                <>
                                    <Col className="pt-4 pb-5 px-5 text-lg-center">
                                        <h3 className="h4">{props.title}</h3>
                                        <p>{props.description}</p>
                                    </Col>
                                    <Col sm={12} md={6} lg={4}>
                                        <div className="timeline-img">
                                            <CustomImage
                                                src={`https://webb-jenkins-static-164679926.imgix.net/${props.image}`}
                                                alt={props.alt}
                                                layout="fill"
                                                objectFit="cover"
                                                objectPosition="center"
                                                sizes="50vw"
                                            />
                                        </div>
                                    </Col>
                                </>
                            )}
                        </Row>
                        <Row className="d-md-none">
                            <Col sm={12} md={6}>
                                <div className="timeline-img">
                                    <CustomImage
                                        src={`https://webb-jenkins-static-164679926.imgix.net/${props.image}`}
                                        alt={props.alt}
                                        layout="fill"
                                        objectFit="cover"
                                        objectPosition="center"
                                        sizes="50vw"
                                    />
                                </div>
                            </Col>
                            <Col className="py-4 px-4 px-sm-5">
                                <h3 className="h4 px-1">{props.title}</h3>

                                <p className="px-1">{props.description}</p>
                            </Col>
                        </Row>
                    </VerticalTimelineElement>
                </animated.div>
            </Waypoint>
        </>
    )
}

export default TimelineElement
